import React from "react";
import UserAvatar from "../../utils/UserAvatar";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaArrowLeft } from "react-icons/fa6";
import ThreadUserAvatar from "./ThreadUserAvatar";
import { useSelector } from "react-redux";

const ThreadHeader = ({ user, onBack, isHidden = false }) => {

  console.log('thread header user', user);

  // NOTE: signed in user state
  const userState = useSelector(state => state?.auth?.user);

  return (
    <div className="flex items-center h-[72px] pl-4 border-b rounded-tr-[30px] border-light-blue bg-[#DEE1DF]">
      <div className=" flex items-center gap-2">
        <button
          onClick={onBack}
          className="lg:hidden text-light-gray hover:text-primary"
        >
          <FaArrowLeft size={20} className="text-primary" />
          
        </button>
        {!isHidden &&
          <ThreadUserAvatar
            firstName={userState?._id?.toString() !== user?.user1?._id ? user?.user1?.firstName || '' : user?.user2?.firstName || ''}
            lastName={userState?._id?.toString() !== user?.user1?._id ? user?.user1?.lastName || '' : user?.user2?.lastName || ''}
            avatar={userState?._id?.toString() !== user?.user1?._id ? user?.user1?.profilePicture : user?.user2?.profilePicture}
            isOnline={true}
            
          />
        }
        <div className="flex flex-col font-inter ">
          <h2 className=" text-dark font-semibold text-level-6 mb-0 leading-6">
          {`${userState?._id?.toString() !== user?.user1?._id ? user?.user1?.firstName || '' : user?.user2?.firstName || ''} ${userState?._id?.toString() !== user?.user1?._id ? user?.user1?.lastName || '' : user?.user2?.lastName || ''}`}
          { isHidden && "Unavailable User"}
          </h2>
          <p className="text-[10px] text-black mt-1">
            {
              `${userState?._id?.toString() !== user?.user1?._id ? user?.user1?.professionalDetails?.primary?.[0]?.categoryName || '' : user?.user2?.professionalDetails?.primary?.[0]?.categoryName || ''}`
            }
          </p>
        </div>
      </div>

      {/* <button className="ml-auto text-primary">
        <BsThreeDotsVertical size={22} />
      </button> */}
    </div>
  );
};

export default ThreadHeader;
